<template>
  <v-app dark>
    <!-- SOS ALERT COMPONENT -->
    <sos-alert />

    <!-- SOS ALERTS INDICATOR -->
    <div v-if="hasMultipleSosAlerts" class="sos-alerts-indicator">
      <i class="material-icons">warning</i>
      <span>{{ totalSosAlerts }}</span>
    </div>

    <!-- HEAT MAP dialog -->
      <v-dialog
        v-model="showHeatMapDialog"
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
      >
        <heat-map @close="setHeatMapDialog(false)" />
      </v-dialog>
    <!-- LOGOUT MODAL -->
    <logout-modal v-if="showLogoutModal"/>
    <!-- NOTIFICATIONS -->
    <v-snackbar
      v-model="showNotification"
      :color="notificationData.error === 0 ? 'blue darken-4' : 'red darken-4'"
      :top="true"
      :auto-height="true"
      :multi-line="true"
      :timeout="0"
    >
      <v-flex>
        <v-flex d-flex class="text-xs-center" pb-2>
          <v-spacer></v-spacer>
          <v-flex class="info-notifications caption font-weight-bold" pa-1>
            {{ `reportes: ${notificationsList.length}` }}
          </v-flex>
        </v-flex>
        <v-flex pb-1>
          {{ notificationData.messageText }}
        </v-flex>
        <v-divider></v-divider>
        <v-flex>
          <v-flex pt-1>
            <v-icon :color="notificationData.error === 0 ? 'blue lighten-3' : 'red lighten-3'" left>directions_car</v-icon>
            {{ notificationData.plate }}
          </v-flex>
          <v-flex pt-1>
            <v-icon :color="notificationData.error === 0 ? 'blue lighten-3' : 'red lighten-3'" left>today</v-icon>
            {{ notificationData.fromDate }}
          </v-flex>
          <v-flex pt-1 pb-2>
            <v-icon :color="notificationData.error === 0 ? 'blue lighten-3' : 'red lighten-3'" left>event</v-icon>
            {{ notificationData.toDate }}
          </v-flex>
        </v-flex>
        <v-divider></v-divider>
        <!-- URL -->
        <v-flex v-if="notificationData.error === 0" d-flex align-center pt-3>
          <v-flex xs1 pl-3>
            <v-icon color="blue lighten-3" left>table_chart</v-icon>
          </v-flex>
          <v-flex>
            <v-btn
              color="primary"
              :href="notificationData.url"
              target="_blank"
              @click="verifyCloseNotification(notificationData.error)"
            >
              <v-icon left>cloud_download</v-icon>
              {{ notificationData.fileName }}
            </v-btn>
          </v-flex>
        </v-flex>
        <!-- ERROR -->
        <v-flex v-else d-flex align-center pt-3>
          <v-flex d-inline-flex align-start>
            <v-icon color="red lighten-3" left>info</v-icon>
            <p>
              Sí el error persiste por favor contactar al administrador del sistema.
            </p>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex>
            <v-btn
              color="error"
              @click="verifyCloseNotification(notificationData.error)"
            >
              Aceptar
            </v-btn>
          </v-flex>
        </v-flex>
      </v-flex>
    </v-snackbar>
    <!-- PUSHER WRAPPER COMPONENT -->
    <pusher-listener v-if="idToken !== null"></pusher-listener>
    <!-- LEFT MAIN MENU -->
    <v-navigation-drawer
      permanent
      fixed
      clipped
      :mini-variant="mini"
      app
    >
      <v-layout column fill-height>
        <v-list class="pt-0" dense>
          <v-divider></v-divider>
          <v-list-tile
            v-for="item in items"
            :key="item.title"
            :to="item.external ? null : item.route"
            @click="item.external ? openExternalLink(item.url) : null"
          >
            <v-tooltip right>
              <template v-slot:activator="{ on }">
                <v-list-tile-action v-on="on">
                  <v-icon>{{ item.icon }}</v-icon>
                </v-list-tile-action>
              </template>
              <span>{{ item.title }}</span>
            </v-tooltip>
          </v-list-tile>
          <!-- <v-list-tile :to="alertRoute.route">
            <v-tooltip right>
              <template v-slot:activator="{ on }">
                <v-list-tile-action v-on="on">
                  <v-badge color="red" overlap>
                    <span
                      slot="badge"
                      v-if="$store.getters['getUnreadAlertsNumber'] !== 0"
                    >
                      {{$store.getters['getUnreadAlertsNumber']}}
                    </span>
                    <v-icon>{{ alertRoute.icon }}</v-icon>
                  </v-badge>
                </v-list-tile-action>
              </template>
              <span>{{ alertRoute.title }}</span>
            </v-tooltip>
          </v-list-tile> -->
        </v-list>
        <v-spacer></v-spacer>
        <!-- LOGO MAYORALITY -->
        <!-- <v-list dense class="py-0">
          <v-flex pb-3>
            <v-img :src="logoMayoralty" height="35px" contain></v-img>
          </v-flex>
        </v-list> -->
      </v-layout>
    </v-navigation-drawer>
    <!-- TOOLBAR -->
    <v-toolbar
      app
      dense
      :clipped-left="$vuetify.breakpoint.lgAndUp"
      fixed>
      <v-btn
        icon
        class="hidden-xs-only"
        v-if="backAvailable"
        @click="goBack">
        <v-icon>arrow_back</v-icon>
      </v-btn>
      <v-toolbar-title>
        <img style="vertical-align:text-top;" width="180" :src="logo"/>
      </v-toolbar-title>
      <v-toolbar-title class="grey--text lighten-1 subheading Navbar__subheader">
        <v-flex class="version-style"> {{ `AVL - V : ${appVersion}` }}</v-flex>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-menu offset-y left>
        <v-avatar size="35px" slot="activator" class="Navbar__avatar">
          <img :src="$store.getters['auth/getProfile'].picture" alt="profile">
        </v-avatar>
        <v-list>
          <v-list-tile>
            <v-list-tile-title>{{$store.getters['auth/getProfile'].nickname}}</v-list-tile-title>
          </v-list-tile>
          <v-list-tile @click="logout">
            <v-list-tile-title>Cerrar sesión</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
    </v-toolbar>
    <!-- CONTENT -->
    <v-content>
      <keep-alive :exclude="excludeComp">
      <!-- <transition name="slide-x-reverse-transition"> -->
        <router-view />
      <!-- </transition> -->
      </keep-alive>
    </v-content>
  </v-app>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import PusherListener from '@/components/PusherListener'
import LogoutModal from '@/components/LogoutModal'
import HeatMap from '@/components/HeatMap'
import SOSAlert from '@/components/SOSAlert.vue'

export default {
  name: 'App',
  components: {
    PusherListener,
    LogoutModal,
    HeatMap,
    'sos-alert': SOSAlert
  },
  data() {
    return {
      appVersion: '1.44.2',
      // logoMayoralty: 'https://dj28xnb5b9x1h.cloudfront.net/images/assets-avl%C2%A0/logoAlcaldiaDeMedellinColors.png',
      excludeComp: [
        'movement-alerts',
        'speed-alerts',
        'edit-geofence-view',
        'app-vehicle-viewer',
        'vehicle-crud',
        'base-alerts',
        'missions-alerts',
        'report-generator',
        'missions-viewer',
        'route-player',
        'parking-alerts',
        'unreported-events-alerts',
        'vehicles-without-events-3h-alerts'
      ],
      logo: 'https://dj28xnb5b9x1h.cloudfront.net/images/assets-omnitrack/omnitrack-logo-dark.svg',
      // logo: 'https://dj28xnb5b9x1h.cloudfront.net/images/logo-letters.svg',
      // logo: 'https://dj28xnb5b9x1h.cloudfront.net/images/assets-avl%C2%A0/logoAVLGenerico.png',
      items: [
        {icon: 'directions_car', title: 'Vehículos', route: '/'},
        {icon: 'security', title: 'Seguimiento a incidentes', external: true, url: process.env.INCIDENTS_URL},
        {icon: 'business', title: 'Agencias', route: '/agencies'},
        {icon: 'memory', title: 'Bitácora', route: '/vehicles-crud'},
        {icon: 'layers', title: 'Cercas', route: '/geofences'},
        {icon: 'access_time', title: 'Minuta de Servicio', route: '/missions/services'},
        {icon: 'notifications', title: 'Alertas', route: '/alerts'},
        {icon: 'table_chart', title: 'Reportes', route: '/reports'},
        {icon: 'bar_chart', title: 'KPI', route: '/k-p-i'}
        // {icon: 'flag', title: 'Misiones', route: '/missions'},
      ],
      // alertRoute: {icon: 'notifications', title: 'Alertas', route: '/alerts'},
      mini: true
    }
  },
  methods: {
    ...mapActions([
      'setNextNotification',
      'spliceNotificationsList',
      'closeNotification',
      'setHeatMapDialog'
    ]),
    verifyCloseNotification(error) {
      if (error === 0) {
        setTimeout(() => { this.notificationAction() }, 1500)
      } else this.notificationAction()
    },
    goBack() {
      this.$router.go(-1)
    },
    logout() {
      this.$store.dispatch('auth/logout')
    },
    notificationAction() {
      this.spliceNotificationsList()
      if (this.notificationsList.length === 0) this.closeNotification()
      else this.setNextNotification()
    },
    openExternalLink(url) {
      // Agregar tanto el auth_token (accessToken) como el idToken como parámetros de query
      const idToken = this.idToken
      const accessToken = localStorage.getItem('accessToken')

      if (idToken && accessToken) {
        const separator = url.includes('?') ? '&' : '?'
        const urlWithTokens = `${url}${separator}auth_token=${encodeURIComponent(accessToken)}&idToken=${encodeURIComponent(idToken)}`
        window.open(urlWithTokens, '_blank')
      } else {
        // Si no hay tokens, abrir sin ellos
        window.open(url, '_blank')
      }
    }
  },
  computed: {
    ...mapGetters([
      'notificationsList',
      'notificationData',
      'showNotification',
      'showHeatMapDialog'
    ]),
    ...mapGetters({
      idToken: 'auth/idToken',
      showLogoutModal: 'auth/showLogoutModal'
    }),
    ...mapGetters('sosAlerts', {
      totalSosAlerts: 'totalAlertsCount',
      hasMultipleSosAlerts: 'hasMultipleAlerts'
    }),
    backAvailable() {
      return (
        this.$route.path !== '/' &&
        this.$route.path !== '/geofences' &&
        this.$route.path !== '/missions' &&
        this.$route.path !== '/alerts'
      )
    }
  },
  async mounted() {
    await this.$store.dispatch('fetchAgenciesTreeAction', 'init')
    this.$store.dispatch('lastPositions')
    this.$store.dispatch('fetchVehicleTypes')
    this.$store.dispatch('filters/initializeFilters')
  }
}
</script>

<style>
  .info-notifications {
    background-color: #F44336;
    border-radius: 12px;
    max-width: 100px;
  }
  .Navbar__subheader {
    font-family: Helvetica Neue, Helvetica, Arial;
  }

  .AppMap__map {
    width: 100%;
    height: 100%;
  }

  .version-style{
    font-size: 7px;
    color: #616161;
    padding-top: 15px;
  }

  /* Indicador de múltiples alertas SOS */
  .sos-alerts-indicator {
    position: fixed;
    top: 20px;
    right: 20px;
    background: linear-gradient(135deg, #ff0000, #cc0000);
    color: white;
    border-radius: 50%;
    width: 50px;
    height: 50px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    z-index: 99998;
    box-shadow: 0 4px 20px rgba(255, 0, 0, 0.5);
    animation: sos-indicator-pulse 1s infinite;
    cursor: pointer;
  }

  .sos-alerts-indicator i {
    font-size: 20px;
    margin-bottom: 2px;
  }

  .sos-alerts-indicator span {
    font-size: 12px;
    font-weight: bold;
    line-height: 1;
  }

  @keyframes sos-indicator-pulse {
    0% {
      transform: scale(1);
      box-shadow: 0 4px 20px rgba(255, 0, 0, 0.5);
    }
    50% {
      transform: scale(1.05);
      box-shadow: 0 6px 25px rgba(255, 0, 0, 0.7);
    }
    100% {
      transform: scale(1);
      box-shadow: 0 4px 20px rgba(255, 0, 0, 0.5);
    }
  }

  /* Responsive para el indicador */
  @media (max-width: 768px) {
    .sos-alerts-indicator {
      top: 15px;
      right: 15px;
      width: 45px;
      height: 45px;
    }

    .sos-alerts-indicator i {
      font-size: 18px;
    }

    .sos-alerts-indicator span {
      font-size: 11px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/App.vue